export default __webpack_public_path__ + "static/media/d11.4ecb3c34.png";